import axios from "axios";
const API_URL = "https://magangprodb.herokuapp.com/api/v1/auth/";
class AuthService {
  login(emailUser, password) {
    return axios
      .post(API_URL + "login", {
        emailUser,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(nama, emailUser, password, jenisKelamin, tempatLahir, tanggalLahir, nomorPonsel) {    
    return axios.post(API_URL + "register/peserta", {
      nama,
      emailUser,
      password,
      jenisKelamin,
      tempatLahir,
      tanggalLahir,
      nomorPonsel
    });
  }

  registerMitra(emailUser, password, namaResmi, namaBrand, website, kategori, sektorBisnis) {    
    return axios.post(API_URL + "register/mitra", {
      emailUser,
      password,
      namaResmi,
      namaBrand,
      website,
      kategori,
      sektorBisnis
    });
  }

  registerMentor(emailUser, password, namaMentor, mitra, proposal) {    
    return axios.post(API_URL + "register/mentor", {
      emailUser,
      password,
      namaMentor,
      mitra,
      proposal
    });
  }

  changePassword(emailUser, oldPassword, newPassword) {
    return axios.post(API_URL + "changepassword", {
      emailUser,
      oldPassword,
      newPassword
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }
}

export default new AuthService();
